import { Routes, Route } from 'react-router-dom';
import Login from '../components/Login'
import { SinglePageLayout } from '../common/layout/singlepage';
import { useUserStore } from '../stores/user-store';
import GPTScreen from '../components/GPT/ChatCtrl';
import ChatCtrl from '../components/GPT/ChatCtrl';

const Root = () => {
    const userData = useUserStore;
    return (

        <Routes>
            <Route path='/login' element={<SinglePageLayout component={Login} />}>
            </Route>
            <Route path='/home' element= {<SinglePageLayout component={ChatCtrl} />}>
            </Route>
            <Route path='/' element= {<SinglePageLayout component={ChatCtrl} />}>
            </Route>
        </Routes>
    );
}

export default Root;